import ContentLoader from 'react-content-loader';
import styles from './style.module.css';

export function ProductAccessoryLoader(props: {count?: number}) {
  return (
    <ContentLoader
      speed={2}
      width={600}
      height={70}
      viewBox="0 0 600 70"
      backgroundColor="#f5f5f5"
      foregroundColor="#ebebeb"
      {...props}
    >
      {/*left  line*/}
      <rect x={0} y={0} rx={3} ry={3} width={3} height={67} />
      {/*right  line*/}
      <rect x={594} y={0} rx={3} ry={3} width={3} height={67} />
      {/*top  line*/}
      <rect x={0} y={0} rx={3} ry={3} width={597} height={3} />
      {/*bottom  line*/}
      <rect x={0} y={64} rx={3} ry={3} width={597} height={3} />
      {/*Inner long line*/}
      <rect x={15} y={19} rx={3} ry={3} width={550} height={12} />

      <rect x={15} y={39} rx={3} ry={3} width={100} height={12} />

      <rect x={135} y={39} rx={3} ry={3} width={50} height={12} />
    </ContentLoader>
  );
}

export default function ProductAccessoryLoaderList(props: {count?: number}) {
  const {count = 1} = props;
  const loaderList = [];
  for (let i = 0; i < count; i++) {
    loaderList.push(
      <div key={i} className={`${styles.accessoriesLoader}`}>
        <ProductAccessoryLoader />
      </div>
    );
  }
  return <>{loaderList}</>;
}
